import { combineReducers } from "redux";
import getRollNumberReducer from "./getRollNumberReducer";

const RollNumberReducer = combineReducers({
    RollNumber: getRollNumberReducer

});

export default RollNumberReducer;
